import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export default function DetailFooter({
  footerControls
}) {
  return /*#__PURE__*/_jsx("div", {
    children: footerControls
  });
}